import { CHCHeaderDropdown } from "./header-dropdown.component.js";
customElements.define("chc-header-dropdown", CHCHeaderDropdown);
export {
  CHCHeaderDropdown
};
//# sourceMappingURL=header-dropdown.js.map
